module.exports = __webpack_public_path__ + "static/media/icon-atom.240f56d9.svg";